import { Component, DestroyRef, Inject, ViewChild, inject, ElementRef } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ServicesService } from 'src/services/services.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize } from 'rxjs/operators';

export interface myStallData {
  so_id: string;
  name: string;
  mobile: string;
  product: string;
  price: string;
  quantity: string;
  action: any;
}


@Component({
  selector: 'app-catalogue-inquiry',
  templateUrl: './catalogue-inquiry.component.html',
  styleUrls: ['./catalogue-inquiry.component.scss']
})
export class CatalogueInquiryComponent {
  displayedColumns: string[] = [
    'so_id',
    'name',
    'mobile',
    'product',
    'price',
    'quantity'
  ];

  ELEMENT_DATA: myStallData[] = [];
  stall_result: any;

  private destoryRef = inject(DestroyRef);

  dataSource = new MatTableDataSource<myStallData>();

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  so_id: any;


  constructor(private service: ServicesService,
    private router: Router,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
  ) { }

  ngAfterViewInit() {
    this.so_id = this.route.snapshot.paramMap.get('so_id');
    this.GetMyStall(this.so_id);
    this.dataSource.paginator = this.paginator;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  GetMyStall(so_id: any) {
    this.ELEMENT_DATA = [];
    this.spinner.show();
    this.service.get_catalogue_inquiry(so_id).pipe(takeUntilDestroyed(this.destoryRef), finalize(() => this.spinner.hide())).subscribe(
      (data: any) => {
        this.stall_result = data.data
        for (const item of this.stall_result) {
          this.ELEMENT_DATA = this.stall_result.map((item: { name: any; mobile: any; so_id: any; product: any, price: any; quantity: any, event_id: any; }, index: number) => ({
            srNo: index + 1,
            name: item.name,
            so_id: item.so_id,
            mobile: item.mobile,
            product: item.product,
            price: item.price,
            quantity: item.quantity
          })
          );
        }
        this.dataSource = new MatTableDataSource<myStallData>(this.ELEMENT_DATA);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.spinner.hide();
      }
    );
  }

}
